module.exports = __webpack_public_path__ + "static/media/gs.1def7829.svg";